/**
 * Theme uses `.open` on sidebar + main header to collapse the nav
 * (margin-left negative / content full width).
 */

const STORAGE_KEY = "justo.sidebar.collapsed";

export const isJustoSidebarCollapsed = () =>
  Boolean(document.querySelector(".page-sidebar")?.classList.contains("open"));

const isMobileViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(max-width: 991.98px)").matches;

export const setJustoSidebarCollapsed = (collapsed) => {
  const header = document.querySelector(".page-main-header");
  const sidebar = document.querySelector(".page-sidebar");
  if (!header || !sidebar) return isJustoSidebarCollapsed();

  const next = Boolean(collapsed);
  if (next) {
    header.classList.add("open");
    sidebar.classList.add("open");
  } else {
    header.classList.remove("open");
    sidebar.classList.remove("open");
  }

  if (!isMobileViewport()) {
    try {
      window.localStorage.setItem(STORAGE_KEY, next ? "1" : "0");
    } catch {
      /* ignore quota / private mode */
    }
  }

  window.dispatchEvent(
    new CustomEvent("justo-sidebar-toggle", {
      detail: { collapsed: next },
    }),
  );

  return next;
};

export const toggleJustoSidebar = () =>
  setJustoSidebarCollapsed(!isJustoSidebarCollapsed());

/** Restore desktop preference; mobile always starts collapsed. */
export const hydrateJustoSidebarPreference = () => {
  if (typeof window === "undefined") return isJustoSidebarCollapsed();
  if (isMobileViewport()) {
    return setJustoSidebarCollapsed(true);
  }
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === "1") return setJustoSidebarCollapsed(true);
    if (saved === "0") return setJustoSidebarCollapsed(false);
  } catch {
    /* ignore */
  }
  return setJustoSidebarCollapsed(false);
};
